import React, { useCallback, useEffect } from 'react';
import { closeMenu, useMenuPosition } from '@client/hooks/use-menu.hooks';
import { Menu } from '@ui/menus/Menu';
import { Icon } from '@ui/Icon';
import { useDeleteElementImport } from './use-delete-element-import.hook';

type ImportKebabMenuProps = {
  importId: string;
  candidateRowIds: readonly string[];
};

/** Context menu for an import file row (opened from {@link ElementListRow} kebab). */
export const ImportKebabMenu: React.FC<ImportKebabMenuProps> = ({
  importId,
  candidateRowIds,
}) => {
  const menuPosition = useMenuPosition(importId);
  const isMenuOpen = Boolean(menuPosition);
  const deleteImport = useDeleteElementImport(importId, candidateRowIds);

  const handleMenuClose = useCallback(() => {
    closeMenu();
  }, []);

  const handleDeleteClick = useCallback(async () => {
    handleMenuClose();
    await deleteImport();
  }, [deleteImport, handleMenuClose]);

  useEffect(() => {
    if (!isMenuOpen) return;
    const handleGlobalContextMenu = () => closeMenu();
    document.addEventListener('contextmenu', handleGlobalContextMenu);
    return () => {
      document.removeEventListener('contextmenu', handleGlobalContextMenu);
    };
  }, [isMenuOpen]);

  return (
    <Menu
      open={isMenuOpen}
      anchorPosition={menuPosition}
      onClose={handleMenuClose}
    >
      <Menu.Item
        icon={<Icon category="mui" icon="DeleteForever" />}
        onClick={handleDeleteClick}
      >
        Delete import
      </Menu.Item>
    </Menu>
  );
};
